// 定义一些公共的属性和方法

// 当前用户使用的帐号是否在登录状态
const isLogin = 0 
// 初始用户的余额是 -1 为什么用负数而不是0 因为用户的余额最多只会是 0 如果为负数表示缓存变量还没有与数据库同步 需要做一次同步的初始休操作
// 这样的好处是，不会遇到用户的余额是 0 时，不断的向后端发起查询请求。
const balance = -1

const app_id = process.env.VUE_APP_ID
const app_key = process.env.VUE_APP_SAE_KEY

const wss = process.env.VUE_APP_WSS
const domain = process.env.VUE_APP_DOMAIN

const wssConnection = null
const wssConID = null // 后端 Ws 长链接的 ID
const token = null
const isBind = false // 是否成功绑定客户端到WS服务器 因为每次刚连上时 要绑定客户端的令牌 服务端才知道要向哪个客户端传递信息
const response = false // 记录WebSocket服务端返回的数据

// 前端开发时，开启调试模式，上线前打包时，关闭。
const debug = false


// 暴露出这些属性
export default ({
    app_id,
    app_key,
    isLogin,
    balance,
    wss,
    domain,
    wssConnection,
    wssConID,
    token,
    isBind,
    response,
    debug
})